import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import wicsLogo from './images/harvard-wics-logo.png';
import googleLogo from './images/google-logo.png';
import { GoogleLoginButton } from "./styles.js";
import { signInWithPopup, GoogleAuthProvider, getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import Events from './Events.js';
import Navbar from './Navbar.js';
import { useNavigate } from 'react-router-dom';

const Login = ({ loggedIn, setLoggedIn }) => {
  //const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  if (loggedIn) navigate("/Events");
  const [errorMessage, setErrorMessage] = useState("");
  const auth = getAuth();
  let userActivityTimer = undefined;

  const logoutUser = () => {

    setLoggedIn(false);
    signOut(auth);
    clearTimeout(userActivityTimer);
    setErrorMessage("Your session has expired. Please log in again.");
    userActivityTimer = undefined;

  };

  useEffect(() => { // should be working... based on old code which was working...

    const unsubscribe = onAuthStateChanged(auth, (user) => {

      if (user) {
        const logoutTime = 8.64 * 10**7;
        //console.log(logoutTime)
        setLoggedIn(true); // set loggedIn to true if user is logged in
        userActivityTimer = setTimeout(logoutUser, logoutTime); // 1 day for inactivity
        document.addEventListener('mousemove', () => {

          clearTimeout(userActivityTimer);
          userActivityTimer = setTimeout(logoutUser, logoutTime); // reset timer on mouse movement

        });

        document.addEventListener('keypress', () => {

          clearTimeout(userActivityTimer);
          userActivityTimer = setTimeout(logoutUser, logoutTime); // reset timer on keypress
        
        });
        
      }
      
      else {

        setLoggedIn(false); // set loggedIn to false if user is logged out

      }

    });

    return () => {

      unsubscribe(); // cleanup function for auth state change listener
      clearTimeout(userActivityTimer); // cleanup function for user activity timer
      userActivityTimer = undefined;

    };
  }, [auth]);

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
    
      .then((result) => {
        // no need to set loggedIn here, will be handled by onAuthStateChanged
        setErrorMessage("");
        navigate("/Events"); // reset error message!
      })
      .catch((error) => { // if not college.harvard.edu

        console.error(error.message);
        setErrorMessage("An error occurred with your Harvard Key login attempt. Please try logging in again.");

      });
  };

  return (
    <div className="container"
      style={{
        display: 'flex',
        justifyContent: loggedIn ? 'left' : 'center', // Center when logged in, left when logged out
        overflowX: 'hidden',
        // paddingRight: '20%',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif'
      }}
      id="logged-out-view">

      {!loggedIn && (
        <div style={{ display: 'inline-block' }}>
          {errorMessage && (<div style={{ 
            position: 'absolute', 
            top: 0, 
            left: '50%', 
            transform: 'translateX(-50%)', 
            zIndex: 1000, 
            backgroundColor: 'white', 
            padding: '10px', 
            color: 'red', 
            whiteSpace: 'nowrap' }}> {errorMessage} </div>)}
          <img src={wicsLogo} alt="WiCS Logo" style={{ width: '30%', height: 'auto' }} />
          <h1>Welcome to WiCS Portal!</h1>
          <h2>Please log in using your Harvard email:</h2>
          <div className="provider-buttons" style={{ display: 'flex', justifyContent: 'center' }}>
            <GoogleLoginButton id="sign-in-with-google-btn" className="provider-btn" onClick={googleSignIn}>
              <img src={googleLogo} alt="Google Logo" style={{ width: '8%', height: 'auto' }} />
              <span>&nbsp;&nbsp;Sign in with Google</span>
            </GoogleLoginButton>
          </div>
        </div>
      )}

      {/* {loggedIn && (
        <>
          <div id="logged-in-view">
          </div>
        </>
      )} */}
    </div>
  );
};

export default Login;